import { render, staticRenderFns } from "./additional_metadata.vue.js?vue&type=template&id=e3770d4a!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata.vue?vue&type=template&id=e3770d4a"
import script from "./additional_metadata.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata.vue?vue&type=script&lang=js"
export * from "./additional_metadata.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./additional_metadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports